import type { ConsoleApiClient } from './console-api-client';

let _apiClient: ConsoleApiClient | null = null;

/**
 * Register the apiClient singleton. Call once at app bootstrap.
 */
export function initApiClient(apiClient: ConsoleApiClient): void {
  if (_apiClient) {
    throw new Error(
      'apiClient already initialized. Call initApiClient() only once.'
    );
  }
  _apiClient = apiClient;
}

/**
 * Access the shared apiClient singleton. Throws if not yet initialized.
 */
export function getApiClient(): ConsoleApiClient {
  if (!_apiClient) {
    throw new Error(
      'apiClient not initialized. Call initApiClient() at app bootstrap.'
    );
  }
  return _apiClient;
}

/** Reset for testing only. */
export function _resetApiClient(): void {
  _apiClient = null;
}
